// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum enumName_emails {
  EmailSentStatus = "EmailSentStatus",
}
